import React from 'react';
import './footer.css';

const Footer = () => (
  <footer className="ep-footer">&#9400; Eggplant {new Date().getFullYear()}.&nbsp; All rights reserved.</footer>
);

export default Footer;
